export default __webpack_public_path__ + "static/media/battmanenergy.419fe205.svg";